import { render } from "./BlockSize.vue?vue&type=template&id=83176b6c&scoped=true&ts=true"
import script from "./BlockSize.vue?vue&type=script&lang=ts"
export * from "./BlockSize.vue?vue&type=script&lang=ts"

import "./BlockSize.vue?vue&type=style&index=0&id=83176b6c&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83176b6c"]])

export default __exports__